module.exports = __webpack_public_path__ + "assets/img/menu-profile-old.be55a50c.svg";